import { request } from "@/store";
import moment from "moment";
import Filter from "@/store/filter";
import { isCampaignThemeDiscovery, isCampaignThemePerformance, isSubset } from "@/utils";
var _ = require("lodash");
const ppcSettings = {
  state: {
    currentWeek: moment().startOf('isoWeek'),
    strategies: [],
    weekFilled: [],
    weeksRange: [],
    products: [],
    boost: null,
    bid: null,
    bid_settings: {},
    sellers_filter: new Filter([], [], "id"),
    marketplaces_filter: new Filter([], [], "sales_channel"),
    currencies_filter: new Filter([], [], "currency"),
    connected_profiles_for_seller: [],
    budget_allocation: [],
    sp_product_prioritization: [],
    sb_product_prioritization: [],
    sp_product_ads_by_campaign_id: new Map(),
    ppc_campaigns: [],
    sp_product_prioritization_by_campaign_id: new Map(),
    sb_product_prioritization_by_campaign_id: new Map(),
    sb_ppc_campaigns: [],
    sp_ppc_campaigns: [],
    sp_ppc_campaigns_by_campaign_id: new Map(),
    sb_ppc_campaigns_by_campaign_id: new Map(),
    bid_simulator: {},
    biddingType: "margin",
    budget_allocation_total_rows: 0,
    product_prioritization_total_rows: 0,
    sb_product_prioritization_total_rows: 0,
    sb_portfolio: {},
    sp_portfolio: {}
  },
  getters: {
    ppcCampaignIdsGet(state) {
      return () => {
        return state.sp_ppc_campaigns.map(campaign => campaign.campaignId);
      };
    },
    ppcCampaignIdsFromSPProductPrioritizationGet(state) {
      return () => {
        return state.sp_product_prioritization.map(campaign_group => campaign_group.campaign_details.map(campaign => campaign.campaign_id)).flat();
      };
    },
    ppcSBCampaignIdsGet(state) {
      return () => {
        return state.sb_ppc_campaigns.map(campaign => campaign.campaignId);
      };
    },
    ppcCampaignGroupIdsGet(state) {
      return () => {
        return state.sp_product_prioritization.map(campaign_group => campaign_group.campaign_group_id);
      };
    },
    ppcSettingsWeeksGet(state) {
      return () => {
        return state.weeksRange.map(weekData => weekData.week);
      };
    },
    ppcBidSimulatorCampaignGroupNameGet(state) {
      return () => {
        let result = state?.bid_simulator["C.Branded"];
        return result ? result[0].campaign_group_name : "";
      };
    },
    ppcBidSimulatorCampaignGroupImageGet(state) {
      return () => {
        let result = state?.bid_simulator["C.Branded"];
        return result ? result[0].campaign_group_image : "";
      };
    },
    ppcBidSimulatorCampaignGroupCountGet(state) {
      return () => {
        let result = state?.bid_simulator["C.Branded"];
        return result ? result[0].campaign_activated_products_count : "";
      };
    }
  },
  mutations: {
    ppcSettingsProductsSet(state, payload) {
      state.products = payload;
    },
    ppcSettingsStrategiesSet(state, payload) {
      state.strategies = payload;
    },
    ppcSettingsBoostSet(state, payload) {
      state.boost = payload;
    },
    ppcSettingsBidSet(state, payload) {
      state.bid = payload;
    },
    ppcBidSettingsSet(state, payload) {
      state.bid_settings = payload;
    },
    ppcBidSettingsBiddingTypeSet(state, payload) {
      state.biddingType = payload;
    },
    ppcSettingsWeekFilled(state, payload) {
      state.weekFilled = payload;
    },
    ppcSettingsWeeksRangeSet(state, payload) {
      state.weeksRange = payload;
    },
    ppcConnectedAdvertisingProfilesSet(state, payload) {
      state.connected_profiles_for_seller = payload;
    },
    ppcSettingsCurrencySet(state, payload) {
      state.currencies_filter = payload;
    },
    ppcBudgetAllocationSet(state, payload) {
      state.budget_allocation = payload;
    },
    ppcProductPrioritizationSet(state, payload) {
      state.sp_product_prioritization = payload;
    },
    ppcProductAdsSet(state, payload) {
      state.sp_product_ads_by_campaign_id = Map.groupBy(payload, ({
        campaignId
      }) => campaignId);
    },
    ppcProductPrioritizationBQByCampaignIdSet(state, payload) {
      state.sp_product_prioritization_by_campaign_id = Map.groupBy(payload, ({
        campaign_id
      }) => campaign_id);
    },
    ppcSBProductPrioritizationBQByCampaignIdSet(state, payload) {
      state.sb_product_prioritization_by_campaign_id = Map.groupBy(payload, ({
        campaign_id
      }) => campaign_id);
    },
    ppcSBProductPrioritizationSet(state, payload) {
      state.sb_product_prioritization = payload;
    },
    ppcCampaignsSet(state, payload) {
      state.sp_ppc_campaigns = payload;
    },
    ppcSBCampaignsSet(state, payload) {
      state.sb_ppc_campaigns = payload;
    },
    ppcSBPortfolioSet(state, payload) {
      state.sb_portfolio = payload;
    },
    ppcSPPortfolioSet(state, payload) {
      state.sp_portfolio = payload;
    },
    ppcCampaignGroupStateSet(state, payload) {
      state.sp_ppc_campaigns_by_campaign_id = Map.groupBy(payload, ({
        campaignId
      }) => campaignId);
      let campaigns = state.sp_ppc_campaigns_by_campaign_id;
      let enabled = {
        enabled: 1
      };
      let paused = {
        enabled: 0
      };
      state.sp_product_prioritization = state.sp_product_prioritization.map(campaign_item => {
        let campaign_details = campaign_item.campaign_details.map(campaign_detail => {
          let campaing_to_merge = campaigns.get(campaign_detail.campaign_id) ?? [];
          return {
            ...campaign_detail,
            ...{
              allocated_budget_current: (campaing_to_merge[0]?.budget?.budget ?? 0) * 7
            }
          };
        });
        let perf_allocated_budget_current = campaign_details.filter(item => item.campaign_theme === "PERF").reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
        let discovery_allocated_budget_current = campaign_details.filter(item => item.campaign_theme === "DISCOVERY").reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
        let perf_allocated_budget_current_enabled_campaigns = campaign_details.filter(item => state.sp_ppc_campaigns_by_campaign_id.get(item["campaign_id"])?.[0].state === "ENABLED")?.filter(item => item.campaign_theme === "PERF")?.reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
        let discovery_allocated_budget_current_enabled_campaigns = campaign_details.filter(item => state.sp_ppc_campaigns_by_campaign_id.get(item["campaign_id"])?.[0].state === "ENABLED")?.filter(item => item.campaign_theme === "DISCOVERY")?.reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
        let campaign_groups = campaign_item.campaign_id_list.map(campaign_id => {
          let campaing_to_merge = campaigns.get(campaign_id) ?? [];
          return campaing_to_merge[0];
        }).filter(item => !!item);
        let campaign_item_by_state = campaign_groups.length > 0 ? Map.groupBy(campaign_groups, ({
          state
        }) => state === 'PAUSED' ? paused : enabled) : new Map();
        let is_enabled = campaign_item_by_state.size == 0 ? "-1" : campaign_item_by_state.size > 1 ? "-1" : campaign_item_by_state.keys().next().value.enabled;
        return {
          ..._.mergeWith(campaign_item, {
            campaign_details: campaign_details,
            perf_allocated_budget_current_enabled_campaigns: perf_allocated_budget_current_enabled_campaigns,
            discovery_allocated_budget_current_enabled_campaigns: discovery_allocated_budget_current_enabled_campaigns,
            perf_allocated_budget_current: perf_allocated_budget_current,
            discovery_allocated_budget_current: discovery_allocated_budget_current
          }, {
            is_enabled: is_enabled
          }, (o, s) => _.isNull(s) ? o : s)
        };
      });
    },
    ppcCampaignUpdateSet(state, payload) {
      let campaigns = Map.groupBy(payload.data, ({
        campaignId
      }) => campaignId);
      let enabled = {
        enabled: 1
      };
      let paused = {
        enabled: 0
      };
      payload.data.forEach(campaign_item => {
        state.sp_ppc_campaigns_by_campaign_id.set(campaign_item.campaign_id, {
          ..._.mergeWith(state.sp_ppc_campaigns_by_campaign_id.get(campaign_item.campaign_id), campaign_item, (o, s) => _.isNull(s) ? o : s)
        });
      });
      state.sp_ppc_campaigns = state.sp_ppc_campaigns.map(campaign => {
        let campaign_to_merge = campaigns.get(campaign.campaignId);
        if (!campaign_to_merge) {
          return campaign;
        }
        return {
          ..._.mergeWith(campaign, campaign_to_merge[0], (o, s) => _.isNull(s) ? o : s)
        };
      });
      state.sp_product_prioritization = state.sp_product_prioritization.map(campaign_item => {
        if (campaign_item.campaign_group_id === payload.campaign_group_id) {
          let campaign_details = campaign_item.campaign_details.map(campaign_detail => {
            let campaing_to_merge = campaigns.get(campaign_detail.campaign_id) ?? [];
            if (campaing_to_merge.length) {
              return {
                ...campaign_detail,
                ...{
                  allocated_budget_current: (campaing_to_merge[0]?.budget?.budget ?? 0) * 7
                }
              };
            }
            return campaign_detail;
          });
          let perf_allocated_budget_current = campaign_details.filter(item => item.campaign_theme === "PERF").reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
          let discovery_allocated_budget_current = campaign_details.filter(item => item.campaign_theme === "DISCOVERY").reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
          let perf_allocated_budget_current_enabled_campaigns = campaign_details.filter(item => state.sp_ppc_campaigns_by_campaign_id.get(item["campaign_id"])?.[0].state === "ENABLED")?.filter(item => item.campaign_theme === "PERF")?.reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
          let discovery_allocated_budget_current_enabled_campaigns = campaign_details.filter(item => state.sp_ppc_campaigns_by_campaign_id.get(item["campaign_id"])?.[0].state === "ENABLED")?.filter(item => item.campaign_theme === "DISCOVERY")?.reduce((accumulator, campaign) => accumulator + campaign?.allocated_budget_current ?? 0, 0);
          let campaign_groups = campaign_item.campaign_id_list.map(campaign_id => {
            let campaing_to_merge = campaigns.get(campaign_id) ?? [];
            return campaing_to_merge[0];
          }).filter(item => !!item);
          let campaign_item_by_state = campaign_groups.length > 0 ? Map.groupBy(campaign_groups, ({
            state
          }) => state === 'PAUSED' ? paused : enabled) : new Map();
          let is_enabled = campaign_item_by_state.size == 0 ? "-1" : campaign_item_by_state.size > 1 ? "-1" : campaign_item_by_state.keys().next().value.enabled;
          return {
            ..._.mergeWith(campaign_item, {
              campaign_details: campaign_details,
              perf_allocated_budget_current: perf_allocated_budget_current,
              perf_allocated_budget_current_enabled_campaigns: perf_allocated_budget_current_enabled_campaigns,
              discovery_allocated_budget_current_enabled_campaigns: discovery_allocated_budget_current_enabled_campaigns,
              discovery_allocated_budget_current: discovery_allocated_budget_current
            }, {
              is_enabled: is_enabled
            }, (o, s) => _.isNull(s) ? o : s)
          };
        }
        return campaign_item;
      });
    },
    ppcCampaignUpdateSBSet(state, payload) {
      payload.forEach(updated_campaign => {
        state.sb_product_prioritization = state.sb_product_prioritization.map(campaign_item => {
          if (campaign_item.campaign_id === updated_campaign.campaign_id) {
            return {
              ...campaign_item,
              state: updated_campaign.state,
              weekly_budget: updated_campaign.budget * 7,
              portfolio_id: updated_campaign.portfolioId
            };
          }
          return campaign_item;
        });
        state.sb_ppc_campaigns_by_campaign_id.set(updated_campaign.campaign_id, {
          ..._.mergeWith(state.sb_ppc_campaigns_by_campaign_id.get(updated_campaign.campaign_id), updated_campaign, (o, s) => _.isNull(s) ? o : s)
        });
        state.sb_ppc_campaigns = state.sb_ppc_campaigns.map(campaign => {
          if (campaign.campaignId !== updated_campaign.campaign_id) {
            return campaign;
          }
          return {
            ..._.mergeWith(campaign, updated_campaign, (o, s) => _.isNull(s) ? o : s)
          };
        });
      });
    },
    ppcSBCampaignGroupStateSet(state, payload) {
      state.sb_ppc_campaigns_by_campaign_id = Map.groupBy(payload, ({
        campaignId
      }) => campaignId);
      const sb_ppc_campaigns_ids = [...state.sb_ppc_campaigns_by_campaign_id.keys()];
      state.sb_product_prioritization = state.sb_product_prioritization.map(campaign => {
        if (sb_ppc_campaigns_ids.includes(campaign.campaign_id)) {
          let result_campaign = state.sb_ppc_campaigns_by_campaign_id.get(campaign.campaign_id)?.[0];
          let updated_campaign = {
            ...campaign,
            ...result_campaign,
            state: result_campaign.state,
            weekly_budget: result_campaign.budget * 7,
            portfolio_id: result_campaign.portfolioId,
            portfolio_name: state.sb_portfolio.name
          };
          return updated_campaign;
        }
        return {
          ...campaign,
          portfolio_id: "",
          portfolio_name: ""
        };
      });
    },
    ppcProductAdUpdateSet(state, payload) {
      payload.forEach(updatedProductAd => {
        state.sp_product_ads_by_campaign_id.set(updatedProductAd.campaignId, state.sp_product_ads_by_campaign_id.get(updatedProductAd.campaignId).map(ad_item => {
          if (ad_item.adId === updatedProductAd.adId) {
            return {
              ...ad_item,
              state: updatedProductAd.state
            };
          }
          return ad_item;
        }));
      });
    },
    ppcBidSimulatorSet(state, payload) {
      state.bid_simulator = payload;
    },
    ppcProductPrioritizationTotalRowsSet(state, payload) {
      state.product_prioritization_total_rows = payload;
    },
    ppcSBProductPrioritizationTotalRowsSet(state, payload) {
      state.sb_product_prioritization_total_rows = payload;
    },
    ppcBudgetStrategySet(state, payload) {
      state.weeksRange = state.weeksRange.map(item => {
        let budget_strategy_items = payload.find(budget_strategy => budget_strategy.week === item.week);
        return {
          ..._.mergeWith({}, item, budget_strategy_items, (o, s) => _.isNull(s) ? o : s)
        };
      });
    },
    ppcSettingsStoreClear(state) {
      state.strategies = [];
      state.bid_settings = {};
      state.connected_profiles_for_seller = [];
      state.sp_product_prioritization = [];
      state.sb_product_prioritization = [];
      state.sp_product_ads_by_campaign_id.clear();
      state.ppc_campaigns = [];
      state.sp_product_prioritization_by_campaign_id.clear();
      state.sb_product_prioritization_by_campaign_id.clear();
      state.sb_ppc_campaigns = [];
      state.sp_ppc_campaigns = [];
      state.sp_ppc_campaigns_by_campaign_id.clear();
      state.sb_ppc_campaigns_by_campaign_id.clear();
      state.bid_simulator = {};
      state.product_prioritization_total_rows = 0;
      state.sb_product_prioritization_total_rows = 0;
      state.sb_portfolio = {};
      state.sp_portfolio = {};
    }
  },
  actions: {
    async ppcBudgetStrategy({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/budget_strategy/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcBudgetStrategySet", result.data);
      }
      return result;
    },
    async ppcBudgetStrategyFromBQ({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/budget_strategy/get_from_bq", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcBudgetStrategySet", result.data);
      }
      return result;
    },
    async ppcProductPrioritizationGetFromBQ({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/sp_product_prioritization/get_from_bq", "POST", payload)) ?? {
        data: [],
        total_rows: 0
      };
      if (result.data) {
        commit("ppcProductPrioritizationSet", result.data);
        commit("ppcProductPrioritizationTotalRowsSet", result.total_rows);
      }
      return result;
    },
    async ppcProductPrioritizationGetFromBQByCampaignId({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/sp_product_prioritization/get_from_bq_by_campaign_id", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcProductPrioritizationBQByCampaignIdSet", result.data);
      }
      return result;
    },
    async ppcSBProductPrioritizationGetFromBQByCampaignId({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/sb_product_prioritization/get_from_bq_by_campaign_id", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcSBProductPrioritizationBQByCampaignIdSet", result.data);
      }
      return result;
    },
    async ppcSBProductPrioritizationGetFromBQ({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/sb_product_prioritization/get_from_bq", "POST", payload)) ?? {
        data: [],
        total_rows: 0
      };
      if (result.data) {
        commit("ppcSBProductPrioritizationSet", result.data);
        commit("ppcSBProductPrioritizationTotalRowsSet", result.total_rows);
      }
      return result;
    },
    async ppcProductPrioritizationCampaigns({
      commit,
      state
    }, payload) {
      let result = (await request("/ppc/campaign/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data && Array.isArray(result.data)) {
        commit("ppcCampaignsSet", result.data);
        commit("ppcCampaignGroupStateSet", result.data);
      }
      return result;
    },
    async ppcSBProductPrioritizationCampaigns({
      commit,
      state,
      dispatch
    }, payload) {
      let result = (await request("/ppc/campaign/sb/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data && Array.isArray(result.data)) {
        commit("ppcSBCampaignsSet", result.data);
        commit("ppcSBCampaignGroupStateSet", result.data);
      }
      return result;
    },
    async ppcSBPortfolios({
      commit,
      state
    }, payload) {
      let result = (await request("/ppc/portfolio/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcSBPortfolioSet", result.data["portfolios"][0]);
        return result?.data["portfolios"][0];
      }
      return result?.data[0];
    },
    async ppcSPPortfolios({
      commit,
      state
    }, payload) {
      let result = (await request("/ppc/portfolio/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcSPPortfolioSet", result.data["portfolios"][0]);
        return result?.data["portfolios"][0];
      }
      return result?.data[0];
    },
    async ppcProductAds({
      commit
    }, payload) {
      let result = (await request("/ppc/product_ad/sp/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data && Array.isArray(result.data)) {
        commit("ppcProductAdsSet", result.data);
      }
      return result;
    },
    async ppcBidSimulatorGetFromBQ({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/bid_simulator/get_from_bq", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        let result_to_save = Object.groupBy(result.data, ({
          targeting_type
        }) => targeting_type);
        commit("ppcBidSimulatorSet", result_to_save);
      }
      return result;
    },
    async ppcBudgetDelete(_, payload) {
      // eslint-disable-next-line no-unused-vars
      await request("/ppc/settings/budget_strategy/delete", "POST", payload);
    },
    async ppcBoost({
      commit
    }, payload) {
      let result = (await request("/ppc/boost", "POST", payload)) ?? {
        data: []
      };
      if (result) {
        commit("ppcSettingsBoostSet", result.data);
      }
      return result;
    },
    async ppcProducts({
      commit
    }, payload) {
      let result = (await request("/ppc/products", "POST", payload)) ?? {
        data: []
      };
      if (result) {
        commit("ppcSettingsProductsSet", result.data);
      }
      return result;
    },
    async ppcBidAdjustement({
      commit
    }, payload) {
      let result = (await request("/ppc/bid", "POST", payload)) ?? {
        data: []
      };
      if (result) {
        commit("ppcSettingsBidSet", result.data);
      }
      return result;
    },
    async refreshPpcBudgetAllocation({
      commit
    }) {
      const data = await request(`/ppc/budget-allocation`);
      if (data) {
        //commit('ppcBudgetAllocationSet', data)
        commit("ppcProductPrioritizationSet", data);
        commit("ppcProductPrioritizationTotalRowsSet", data.length);
      }
      return data;
    },
    async ppcBudgetAllocationUpdate({
      state,
      commit
    }, payload) {
      // To save the updated value using current state instead default one
      const updatedData = state.budget_allocation.map(item => {
        if (item.campaign_group_id === payload.campaign_group_id) {
          return payload;
        }
        return item;
      });
      commit('ppcBudgetAllocationSet', updatedData);
      const data = await request(`/ppc/budget-allocation`);
      if (data) {
        // commit('ppcBudgetAllocationSet', data)
      }
      return data;
    },
    ppcProductPrioritizationUpdate({
      state,
      commit
    }, payload) {
      const updatedData = state.sp_product_prioritization.map(item => {
        if (item.campaign_group_id === payload.campaign_group_id) {
          return payload;
        }
        return item;
      });
      commit('ppcProductPrioritizationSet', updatedData);
    },
    ppcSbProductPrioritizationUpdate({
      state,
      commit
    }, payload) {
      const updatedData = state.sb_product_prioritization.map(item => {
        if (item.campaign_id === payload.campaign_id) {
          return payload;
        }
        return item;
      });
      commit('ppcSBProductPrioritizationSet', updatedData);
    },
    async ppcProductPrioritizationCampaignGroups({
      commit,
      state
    }, payload) {
      let result = (await request("/ppc/campaign/group/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        state.sp_product_prioritization = state.sp_product_prioritization.map(item => {
          const campaign_group = result.data.find(campaign_group => campaign_group.campaign_group_id === item.campaign_group_id);
          if (campaign_group) {
            return {
              ...item,
              boost: campaign_group.boost,
              is_blocked: campaign_group.is_blocked
            };
          }
          return item;
        });
      }
    },
    async ppcSBProductPrioritizationCampaignGroups({
      commit,
      state
    }, payload) {
      let result = (await request("/ppc/campaign/group/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        state.sb_product_prioritization = state.sb_product_prioritization.map(item => {
          const campaign_group = result.data.find(campaign_group => campaign_group.campaign_group_id === item.campaign_id);
          if (campaign_group) {
            return {
              ...item,
              boost: campaign_group.boost
            };
          }
          return item;
        });
      }
    },
    async ppcProductPrioritizationCampaignGroupUpdate(_, payload) {
      const result = await request("/ppc/campaign/group/update", "POST", {
        data: payload
      });
      return result;
    },
    async ppcStrategiesSave(_, payload) {
      // eslint-disable-next-line no-unused-vars
      let result = (await request("/ppc/settings/budget_strategy/create", "POST", payload)).data;
      return result;
    },
    async ppcBidSettingGet({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/bid_settings/get", "POST", payload)) ?? {
        data: []
      };
      if (result) {
        commit("ppcBidSettingsSet", result.data[0] || {
          profile_id: payload.profile_list[0],
          seller_id: payload.seller_list[0],
          marketplace_id: payload.marketplace_id,
          non_branded_keyword_targeting: 1,
          branded_keyword_product_targeting: 0.4,
          competitor_product_targeting: 1,
          discovery_targeting: 1
        });
      }
      return result;
    },
    async ppcBidSettingSave({
      commit
    }, payload) {
      let result = await request("/ppc/settings/bid_settings/create", "POST", payload);
      if (result?.status.includes("success")) {
        commit("ppcBidSettingsSet", payload.data[0]);
      }
      return result;
    },
    async ppcBidSettingsLtvGet(_, payload) {
      let result = (await request("/ppc/settings/bid_settings_ltv/get", "POST", payload)) ?? {
        data: []
      };
      return result;
    },
    async ppcBidSettingsHourlyAmcGet(_, payload) {
      let result = (await request("/ppc/settings/bid_settings_hourly_amc/get", "POST", payload)) ?? {
        data: []
      };
      return result;
    },
    async ppcBidSettingsPlacementAmcGet(_, payload) {
      let result = (await request("/ppc/settings/bid_settings_placement_amc/get", "POST", payload)) ?? {
        data: []
      };
      return result;
    },
    async ppcBidSettingsSeasonalAmcGet(_, payload) {
      let result = (await request("/ppc/settings/bid_settings_seasonal_amc/get", "POST", payload)) ?? {
        data: []
      };
      return result;
    },
    async ppcHistoricalBidSettingGet(_, payload) {
      let result = (await request("/ppc/settings/bid_settings/get_historical", "POST", payload)).data;
      //console.log("bid settings: ", result);
      return result;
    },
    async ppcEditCampaign(_, payload) {
      const data = await request("/ppc/edit_campaign", "POST", payload);
      if (data) {
        return data;
      }
    },
    async ppcEditCampaignSB(_, payload) {
      const data = await request("/ppc/edit_campaign_sb", "POST", payload);
      if (data) {
        return data;
      }
    },
    async ppcEditProductAd(_, payload) {
      const data = await request("/ppc/edit_product_ad_sp", "POST", payload);
      if (data) {
        return data;
      }
    },
    ppcSettingsClearStrategies({
      commit
    }) {
      commit("ppcSettingsStrategiesSet", []);
      commit("ppcSettingsWeekFilled", []);
    },
    ppcSettingsInitializeSellers({
      commit
    }, payload) {
      commit("ppcSellersFilterSet", payload);
    },
    ppcSettingsInitializeMarketplaces({
      commit
    }, payload) {
      commit("ppcMarketplacesFilterSet", payload);
    },
    ppcSettingsClearStore({
      commit
    }) {
      commit("ppcSettingsStoreClear");
    }
  }
};
export default ppcSettings;